/**
 * @render react
 * @name Form
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'recompose';

import { withAmp } from 'Components/protons/withAmp';
import { withPolaris } from 'Components/protons/Polaris';

import renderAmp from './amp';

/**
 * Form component
 *
 * @param {string} action - form action url
 * @param {string} target - form target
 * @param {string} role - form role
 * @param {string} method - form method
 * @param {node} children - Components to be added as a child
 * @param {object} onSubmit - function to be called on form is submitted
 * @param {boolean} loadStyles - Whether to apply the class names for styling.
 * @param {Object} extraClassNames - extra classes to be applied to the component
 * @param {Object} context - Extra information coming from Polaris provider.
 */
class Form extends Component {
  /**
   * Renders the amp version of the component.
   */
  amp() {
    return renderAmp.bind(this)();
  }

  /**
   * Render function
   */
  render() {
    const {
      action,
      target,
      role,
      method,
      onSubmit,
      children,
      loadStyles,
      extraClassNames,
      context: { cssPrefix },
    } = this.props;

    return (
      <form
        action={action}
        target={target || undefined}
        role={role}
        method={method}
        onSubmit={onSubmit || undefined}
        className={classNames({
          [`${cssPrefix}__form`]: loadStyles,
          ...extraClassNames,
        })}
      >
        {children}
      </form>
    );
  }
}

/**
 * Prop types
 */
Form.propTypes = {
  action: PropTypes.string,
  target: PropTypes.string,
  role: PropTypes.string,
  method: PropTypes.string,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  loadStyles: PropTypes.bool,
  extraClassNames: PropTypes.instanceOf(Object),
  context: PropTypes.shape(),
  ampScripts: PropTypes.shape(), // eslint-disable-line
};

/**
 * Default props
 */
Form.defaultProps = {
  action: '',
  target: '',
  role: '',
  method: 'post',
  onSubmit: null,
  children: null,
  loadStyles: true,
  extraClassNames: {},
  context: {},
  ampScripts: {
    'amp-form': 'https://cdn.ampproject.org/v0/amp-form-0.1.js',
  },
};

export default compose(withPolaris, withAmp)(Form);
